import { createFileRoute, notFound } from "@tanstack/react-router";

import { RAIL, SOON } from "@/app/shell/nav";
import { SoonPage } from "@/app/shell/SoonPage";
import { requireSection } from "@/shared/auth/access";

/** An entry of the v1 menu whose screen is not built here yet. */
export const Route = createFileRoute("/_app/soon/$entry")({
  beforeLoad: ({ context, params }) => {
    const entry = RAIL.find((each) => each.to === SOON && each.id === params.entry);
    if (entry === undefined) throw notFound();
    requireSection(context.role, entry.section);
  },
  component: Soon,
});

function Soon() {
  const { entry: id } = Route.useParams();
  const entry = RAIL.find((each) => each.to === SOON && each.id === id);
  return entry === undefined ? null : <SoonPage entry={entry} />;
}
